// Store configs with their callbacks outside of reactive state to avoid Vue 3 Proxy issues
const configStack = [];

export default {
  namespaced: true,
  state: {
    stackVersion: 0, // Used to trigger reactivity updates
    hidden: false,
  },
  mutations: {
    incrementStackVersion: (state) => {
      state.stackVersion += 1;
    },
    setHidden: (state, value) => {
      state.hidden = value;
    },
  },
  getters: {
    config: ({ hidden, stackVersion }) => {
      // stackVersion is used to trigger reactivity when stack changes
      void stackVersion;
      return !hidden && configStack[0];
    },
  },
  actions: {
    async open({ commit }, param) {
      const config = typeof param === 'object' ? { ...param } : { type: param };
      try {
        return await new Promise((resolve, reject) => {
          // Attach callbacks directly to the config object
          config.resolve = resolve;
          config.reject = reject;
          // Add to non-reactive stack
          configStack.unshift(config);
          commit('incrementStackVersion');
        });
      } finally {
        const index = configStack.indexOf(config);
        if (index !== -1) {
          configStack.splice(index, 1);
        }
        commit('incrementStackVersion');
      }
    },
    async hideUntil({ commit }, promise) {
      try {
        commit('setHidden', true);
        return await promise;
      } finally {
        commit('setHidden', false);
      }
    },
  },
};
